import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
})
export class TooltipComponent {
  @Input() iconSize = 22;
  @Input() src = '/assets/icons/svg/round-info.svg';
  @Input() customClass: string = 'red-icon';
  @Input() position: 'left' | 'right' = 'left';
}
